import { cloneDeep } from 'core/utils/lang'

import { type PreferredLane } from './PreferredLane'

export type SuggestedPreferredLane = PreferredLane & {
  suggestionDate: Date
  dismissed: boolean
  action: SuggestedPreferredLaneAction
}

export const enum SuggestedPreferredLaneAction {
  Bid = 'bid',
  Book = 'book',
  Search = 'search',
}

export function createSuggestedPreferredLane(
  preferredLane: PreferredLane,
  action: SuggestedPreferredLaneAction
): SuggestedPreferredLane {
  return {
    ...cloneDeep(preferredLane),
    suggestionDate: new Date(),
    dismissed: false,
    action,
  }
}

export function dismissSuggestedPreferredLane(
  suggestedPreferredLane: SuggestedPreferredLane
): SuggestedPreferredLane {
  const result = cloneDeep(suggestedPreferredLane)

  result.dismissed = true

  return result
}

export function updateSuggestedPreferredLane(
  suggestedPreferredLane: SuggestedPreferredLane,
  action: SuggestedPreferredLaneAction
): SuggestedPreferredLane {
  const result = cloneDeep(suggestedPreferredLane)

  result.suggestionDate = new Date()
  result.dismissed = false
  result.action = action

  return result
}
